import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import {
  GET_NODE_EDGE,
  UPDATE_NODE_EDGE
} from "../actions";

import {
  getNodeEdgeSuccess,
  getNodeEdgeError,
  updateNodeEdgeSuccess,
  updateNodeEdgeError,
} from "./actions";

export function* watchGetNodeEdge() {
  yield takeEvery(GET_NODE_EDGE, getNodeEdge);
}

export function* watchUpdateNodeEdge() {
  yield takeEvery(UPDATE_NODE_EDGE, updateNodeEdge);
}

const getNodeEdgeAsync = async (payload) => {
  try {

    const recordNodeEdgeListReturned = await centralApiAxios.get("node_edges/"+payload.edgeId);

    if (recordNodeEdgeListReturned.data) {
      return {
        nodeEdge: recordNodeEdgeListReturned.data,
        message: null,
      };
    }
    return { message: "Get node edge failed." };
  } catch (error) {
    return {
      message: "Failed to get node edge. ",
    };
  }
};

function* getNodeEdge({ payload }) {
  try {
    const returnedData = yield call(getNodeEdgeAsync, payload);
    if (!returnedData.message) {
      yield put(
        getNodeEdgeSuccess({
          nodeEdge: returnedData.nodeEdge,
        })
      );
    } else {
      yield put(getNodeEdgeError(returnedData.message));
    }
  } catch (error) {
    yield put(getNodeEdgeError(error));
  }
}

const updateNodeEdgeAsync = async (payload) => {
  try {

    const recordNodeEdgeListReturned = await centralApiAxios.delete("node_edges?trash=true&id=" + payload.nodeEdge.node_edge_id);

    if (recordNodeEdgeListReturned.data) {
      return {
        nodeEdge: recordNodeEdgeListReturned.data,
        message: null,
      };
    }
    return { message: "Get node edge failed." };
  } catch (error) {
    alert(error);
    return {
      message: "Failed to get node edge. ",
    };
  }
};

function* updateNodeEdge({ payload }) {
  // eslint-disable-next-line
  const { history, collection_id } = payload;
  try {
    
    const returnedData = yield call(updateNodeEdgeAsync, payload);
    if (!returnedData.message) {
      yield put(
        updateNodeEdgeSuccess({
          nodeEdge: returnedData.nodeEdge,
        })
      );
      history.push("/app/collectionitempeople/"+ payload.collection_id);
      window.location.reload();
    } else {
      yield put(updateNodeEdgeError(returnedData.message));
    }
  } catch (error) {
    yield put(updateNodeEdgeError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetNodeEdge),
    fork(watchUpdateNodeEdge),
  ]);
}

